export default "__VITE_ASSET__ad211b41__"